import { gql } from '@apollo/client';

const GET_POSTS  = gql`
  query GetPosts($categoryName: String, $numPosts: Int!, $lang: String) {
    posts(
      last: $numPosts, 
      where: { 
        categoryName: $categoryName, 
        language: $lang 
      }
    ) 
    {
      nodes {
        slug
        title
        content
        featuredImage {
          node {
            mediaItemUrl
          }
        }
        categories {
          nodes {
            name
          }
        }
      }
    }
  }
`;

export { GET_POSTS }

